"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IPDATA_API_KEY = void 0;
var IPDATA_API_KEY = 'cbf98729ab58d468af79d5c9cddc2c4e58e3459c8526c566a81e3143';
exports.IPDATA_API_KEY = IPDATA_API_KEY;